module.exports = "/fonts/vendor/summernote/dist/summernote.woff?7222f2aa6fc35e05281c7aa793342870";